import { jsxs as i, jsx as r } from "react/jsx-runtime";
import l from "classnames";
import { Wrapper as m, Text as d, TextInner as p, ImgWrapper as a, Img as x } from "./styled.js";
const h = ({
  className: o = "",
  text: n,
  imgUrl: t,
  backgroundColorPrimary: e = "",
  backgroundColorSecondary: c = ""
}) => /* @__PURE__ */ i(
  m,
  {
    className: l({ [o]: !!o }),
    $backgroundColor: e,
    children: [
      /* @__PURE__ */ r(d, { children: /* @__PURE__ */ r(p, { children: n }) }),
      /* @__PURE__ */ r(
        a,
        {
          $imgUrl: t,
          $backgroundColorPrimary: e,
          $backgroundColorSecondary: c,
          children: /* @__PURE__ */ r(x, {})
        }
      )
    ]
  }
);
export {
  h as Title,
  h as default
};
